module.exports = __webpack_public_path__ + "img/u-newDocking.903cf87c.jpg";